import * as Sentry from '@sentry/react-native';

import { getClientTrackingProperties } from '@/utils/clientIdentity';

import type { TrackingInterface } from '../_types';
import { getPlatformSentryOptions } from './sentryOptions';

export function sentryTracker(
  dsn: string,
  environment: string,
): TrackingInterface {
  const initialize = async () => {
    if (!dsn) {
      console.warn('Sentry DSN not configured, skipping initialization');
      return;
    }

    Sentry.init({
      dsn,
      environment,
      sendDefaultPii: true,
      enableLogs: true,
      // Tagged from the first event; the session-wide setTags runs later.
      initialScope: { tags: getClientTrackingProperties() },
      ...getPlatformSentryOptions(environment),
    });
  };

  const setUserId: TrackingInterface['setUserId'] = (userId, context) => {
    Sentry.setUser({ id: userId, ...context });
  };

  const trackScreenName: TrackingInterface['trackScreenName'] = (
    name,
    params,
  ) => {
    Sentry.addBreadcrumb({
      message: `PageView: ${name}`,
      data: { name, ...params },
      level: 'info',
      type: 'navigation',
    });
  };

  const setTags: TrackingInterface['setTags'] = (tags) => {
    Sentry.setTags(tags);
  };

  return Object.freeze({
    initialize,
    setUserId,
    setTags,
    trackScreenName,
  });
}
